
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'cnpj',
        label: 'CNPJ',
        mask: 'cnpj',
        prefix: 'fa fa-credit-card',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'cpf',
        label: 'CPF',
        mask: 'cpf',
        prefix: 'fa fa-credit-card',
        rules: ['required']
    },

]



// WEBPACK FOOTER //
// ./src/components/apps/empresa/login/_form/reset.js